export default {
  moduleName: 'student',
  apis: [
    {
      funName: 'info',
      methodType: 'get',
      url: 'info'
    },
    {
      funName: 'findPersonPage',
      methodType: 'get',
      url: 'page/person'
    },
    {
      funName: 'findTeamPage',
      methodType: 'get',
      url: 'page/team'
    },
    {
      funName: 'queryPerson',
      methodType: 'post',
      url: 'page/person'
    },
    {
      funName: 'queryPersonList',
      methodType: 'post',
      url: 'list/person'
    },
    {
      funName: 'queryTeam',
      methodType: 'post',
      url: 'page/team'
    },
    {
      funName: 'queryTeamList',
      methodType: 'post',
      url: 'list/team'
    },
    {
      funName: 'findList',
      methodType: 'get',
      url: 'list'
    },
    {
      funName: 'findPage',
      methodType: 'get',
      url: 'page'
    },
    {
      funName: 'insert',
      methodType: 'post',
      url: 'insert'
    },
    {
      funName: 'update',
      methodType: 'post',
      url: 'update'
    },
    {
      funName: 'deleteStudent',
      methodType: 'get',
      url: 'delete'
    },
    {
      funName: 'getAreaCount',
      methodType: 'get',
      url: 'area/count'
    }
  ]
}